import React from 'react';
import '../../components/CSS/About.css';
import AboutHero from '../../components/AboutHero';
import Toolkit from '../../components/Toolkit';
import Vision from '../../components/Vision';
import Mission from '../../components/Mission';
import Services from '../../components/Services';
import CTA from '../../components/CTA';
import Testimonials from '../../components/Testimonials';
import OurPromise from '../../components/OurPromise';
import BrandsPartnerships from '../../components/BrandsPartnerships';
import SEOHead from '../../components/SEO/SEOHead';
import { seoConfig } from '../../components/SEO/seoConfig';
import { organizationSchema, createBreadcrumbSchema } from '../../components/SEO/schemas';

const About = () => {
  const breadcrumbs = [
    { name: 'Home', url: process.env.REACT_APP_SITE_URL || 'https://fixinn.co.uk' },
    { name: 'About', url: `${process.env.REACT_APP_SITE_URL || 'https://fixinn.co.uk'}/about` }
  ];

  const combinedSchema = [organizationSchema, createBreadcrumbSchema(breadcrumbs)];

  return (
    <>
      {/* <SEOHead
        title={seoConfig.about.title}
        description={seoConfig.about.description}
        keywords={seoConfig.about.keywords}
        canonical={seoConfig.about.canonical}
        ogTitle={seoConfig.about.ogTitle}
        ogDescription={seoConfig.about.ogDescription}
        ogImage={seoConfig.about.ogImage}
        ogUrl={seoConfig.about.canonical}
        structuredData={combinedSchema}
      /> */}
      <div className="about-page">
        <AboutHero />
        <Toolkit />
        <Services />
        <Vision />
        <Mission />
        <OurPromise />
        <BrandsPartnerships />
        <Testimonials background={'white'} />
        <CTA background={true} />
      </div>
    </>
  );
};

export default About;